module.exports = __webpack_public_path__ + "media/gameboy-white.de6e65ca.mp4";